// Extra data from https://instances.vantage.sh/
export const vCPUbyInstanceType: Record<string, number> = {
    "r6idn.12xlarge": 48,
    "c5n.18xlarge": 72,
    "r6id.8xlarge": 32,
    "i3en.12xlarge": 48,
    "m6in.xlarge": 4,
    "x2iedn.32xlarge": 128,
    "c5.18xlarge": 72,
    "c6in.metal": 128,
    "c7a.8xlarge": 32,
    "c5n.9xlarge": 36,
    "x1e.16xlarge": 64,
    "r7iz.8xlarge": 32,
    "r6idn.metal": 128,
    "r4.4xlarge": 16,
    "m6id.2xlarge": 8,
    "m5d.8xlarge": 32,
    "x2idn.metal": 128,
    "m8g.8xlarge": 32,
    "c5d.24xlarge": 96,
    "c5d.metal": 96,
    "m5.12xlarge": 48,
    "i7i.24xlarge": 96,
    "r4.2xlarge": 8,
    "c5n.metal": 72,
    "r7gd.metal": 64,
    "r7iz.12xlarge": 48,
    "r5n.metal": 96,
    "i3en.large": 2,
    "c8g.metal-48xl": 192,
    "m7i.16xlarge": 64,
    "m6i.8xlarge": 32,
    "r5.2xlarge": 8,
    "m5a.xlarge": 4,
    "c5d.9xlarge": 36,
    "i7ie.24xlarge": 96,
    "m7i.xlarge": 4,
    "m8g.16xlarge": 64,
    "r6id.16xlarge": 64,
    "m7a.8xlarge": 32,
    "i4i.2xlarge": 8,
    "r5d.24xlarge": 96,
    "m5ad.16xlarge": 64,
    "g6e.2xlarge": 8,
    "c6id.12xlarge": 48,
    "m6id.32xlarge": 128,
    "m7a.xlarge": 4,
    "r7i.xlarge": 4,
    "m6id.12xlarge": 48,
    "r6a.24xlarge": 96,
    "c7g.8xlarge": 32,
    "m5.8xlarge": 32,
    "i4i.xlarge": 4,
    "c6id.32xlarge": 128,
    "r5d.16xlarge": 64,
    "m5d.2xlarge": 8,
    "g6e.12xlarge": 48,
    "m8g.xlarge": 4,
    "z1d.2xlarge": 8,
    "m5d.24xlarge": 96,
    "r5ad.4xlarge": 16,
    "m5.4xlarge": 16,
    "m5dn.24xlarge": 96,
    "m5dn.16xlarge": 64,
    "r5dn.8xlarge": 32,
    "c6i.large": 2,
    "r6idn.8xlarge": 32,
    "r6idn.4xlarge": 16,
    "c6in.2xlarge": 8,
    "m5dn.8xlarge": 32,
    "d3.xlarge": 4,
    "c4.xlarge": 4,
    "z1d.large": 2,
    "r5a.8xlarge": 32,
    "m5zn.3xlarge": 12,
    "r7gd.large": 2,
    "r6id.32xlarge": 128,
    "c6i.16xlarge": 64,
    "x1e.32xlarge": 128,
    "i3en.24xlarge": 96,
    "r5ad.2xlarge": 8,
    "g5.8xlarge": 32,
    "t4g.large": 2,
    "r5b.12xlarge": 48,
    "r8gd.12xlarge": 48,
    "inf1.2xlarge": 8,
    "c5a.24xlarge": 96,
    "c5ad.large": 2,
    "m6id.16xlarge": 64,
    "r5a.xlarge": 4,
    "x2iedn.16xlarge": 64,
    "m6gd.xlarge": 4,
    "c6id.metal": 128,
    "r7a.12xlarge": 48,
    "r5b.large": 2,
    "c7i.metal-24xl": 96,
    "r5a.24xlarge": 96,
    "t3.xlarge": 4,
    "i4i.12xlarge": 48,
    "i3en.6xlarge": 24,
    "t4g.micro": 2,
    "m5dn.12xlarge": 48,
    "u-6tb1.112xlarge": 448,
    "m6i.12xlarge": 48,
    "r6a.4xlarge": 16,
    "r6a.2xlarge": 8,
    "m5.xlarge": 4,
    "r5ad.16xlarge": 64,
    "u-6tb1.56xlarge": 224,
    "r6a.xlarge": 4,
    "m6in.metal": 128,
    "r6id.metal": 128,
    "m6in.16xlarge": 64,
    "im4gn.4xlarge": 16,
    "r3.8xlarge": 32,
    "r3.large": 2,
    "c7i-flex.12xlarge": 48,
    "c7a.metal-48xl": 192,
    "c7i.12xlarge": 48,
    "inf1.xlarge": 4,
    "r5n.large": 2,
    "c5.xlarge": 4,
    "m4.10xlarge": 40,
    "c5.metal": 96,
    "m5n.12xlarge": 48,
    "t3a.2xlarge": 8,
    "x2iedn.24xlarge": 96,
    "r6in.metal": 128,
    "m6id.xlarge": 4,
    "m7a.16xlarge": 64,
    "m6idn.metal": 128,
    "x2iedn.xlarge": 4,
    "t3a.small": 2,
    "m7gd.16xlarge": 64,
    "r6id.2xlarge": 8,
    "t3a.xlarge": 4,
    "r5n.xlarge": 4,
    "m7gd.medium": 1,
    "c7a.medium": 1,
    "r6id.24xlarge": 96,
    "m6i.2xlarge": 8,
    "r8gd.16xlarge": 64,
    "r7i.16xlarge": 64,
    "c5.9xlarge": 36,
    "r5dn.large": 2,
    "m5a.16xlarge": 64,
    "c6a.32xlarge": 128,
    "m7i.metal-48xl": 192,
    "m5d.metal": 96,
    "r6g.medium": 1,
    "c7gn.xlarge": 4,
    "c6a.large": 2,
    "i7ie.12xlarge": 48,
    "r5ad.24xlarge": 96,
    "r5d.12xlarge": 48,
    "r7a.medium": 1,
    "r6in.24xlarge": 96,
    "r7a.2xlarge": 8,
    "c5ad.8xlarge": 32,
    "r5n.8xlarge": 32,
    "m5a.8xlarge": 32,
    "c6i.xlarge": 4,
    "c5.2xlarge": 8,
    "r6g.16xlarge": 64,
    "t4g.medium": 2,
    "m5dn.2xlarge": 8,
    "r5a.large": 2,
    "r5b.8xlarge": 32,
    "m6a.24xlarge": 96,
    "c6id.large": 2,
    "m6in.32xlarge": 128,
    "r5d.8xlarge": 32,
    "t3.nano": 2,
    "m6a.2xlarge": 8,
    "r7i.metal-24xl": 96,
    "r5b.2xlarge": 8,
    "r8g.metal-48xl": 192,
    "x2iedn.metal": 128,
    "m6id.metal": 128,
    "r3.4xlarge": 16,
    "c7a.32xlarge": 128,
    "z1d.12xlarge": 48,
    "t3.large": 2,
    "g5.48xlarge": 192,
    "m7a.12xlarge": 48,
    "m6a.large": 2,
    "g5.12xlarge": 48,
    "c6id.4xlarge": 16,
    "c5n.2xlarge": 8,
    "m6id.24xlarge": 96,
    "m5zn.metal": 48,
    "c5n.xlarge": 4,
    "i2.2xlarge": 8,
    "r6a.32xlarge": 128,
    "m6in.12xlarge": 48,
    "r7a.8xlarge": 32,
    "m6i.large": 2,
    "m4.2xlarge": 8,
    "m6i.32xlarge": 128,
    "r5d.4xlarge": 16,
    "m7a.32xlarge": 128,
    "i4i.4xlarge": 16,
    "m7i.large": 2,
    "r6in.4xlarge": 16,
    "r6idn.16xlarge": 64,
    "r6i.2xlarge": 8,
    "r7i.8xlarge": 32,
    "r6idn.32xlarge": 128,
    "im4gn.large": 2,
    "r7a.16xlarge": 64,
    "r6i.metal": 128,
    "r7g.xlarge": 4,
    "m7i.8xlarge": 32,
    "m6idn.xlarge": 4,
    "i7i.2xlarge": 8,
    "d3.2xlarge": 8,
    "c7i-flex.2xlarge": 8,
    "m5zn.6xlarge": 24,
    "c7gd.xlarge": 4,
    "r7a.xlarge": 4,
    "h1.4xlarge": 16,
    "r8g.12xlarge": 48,
    "c7i.xlarge": 4,
    "m8gd.4xlarge": 16,
    "r6i.large": 2,
    "m6a.8xlarge": 32,
    "m5n.large": 2,
    "c5d.large": 2,
    "r5.16xlarge": 64,
    "r6gd.4xlarge": 16,
    "r6a.large": 2,
    "a1.medium": 1,
    "i3en.2xlarge": 8,
    "c6i.24xlarge": 96,
    "c5.4xlarge": 16,
    "r3.2xlarge": 8,
    "r8g.medium": 1,
    "r5.metal": 96,
    "c8g.12xlarge": 48,
    "r8gd.48xlarge": 192,
    "c5a.12xlarge": 48,
    "r6a.16xlarge": 64,
    "m6i.16xlarge": 64,
    "c8g.xlarge": 4,
    "g6.xlarge": 4,
    "i4i.metal": 128,
    "i7ie.large": 2,
    "t2.micro": 1,
    "r5ad.xlarge": 4,
    "c6in.large": 2,
    "m8gd.16xlarge": 64,
    "c6id.24xlarge": 96,
    "c6i.metal": 128,
    "c6id.2xlarge": 8,
    "r7a.4xlarge": 16,
    "c6gn.12xlarge": 48,
    "c7gd.large": 2,
    "u-18tb1.112xlarge": 448,
    "g6e.8xlarge": 32,
    "m6id.8xlarge": 32,
    "g6e.xlarge": 4,
    "m5.large": 2,
    "c6a.16xlarge": 64,
    "m5ad.8xlarge": 32,
    "r7i.48xlarge": 192,
    "r7i.4xlarge": 16,
    "r5ad.8xlarge": 32,
    "m7a.48xlarge": 192,
    "c5d.18xlarge": 72,
    "c6gn.large": 2,
    "c7a.large": 2,
    "c6a.xlarge": 4,
    "c4.4xlarge": 16,
    "p4d.24xlarge": 96,
    "c7gn.large": 2,
    "c7a.4xlarge": 16,
    "i7ie.xlarge": 4,
    "r6id.4xlarge": 16,
    "c7a.24xlarge": 96,
    "m5n.16xlarge": 64,
    "t3a.medium": 2,
    "c6gn.4xlarge": 16,
    "m5a.large": 2,
    "m6a.48xlarge": 192,
    "i4i.16xlarge": 64,
    "m7i.48xlarge": 192,
    "g4dn.8xlarge": 32,
    "m5ad.large": 2,
    "r5.4xlarge": 16,
    "r7iz.16xlarge": 64,
    "c7i.8xlarge": 32,
    "i7i.8xlarge": 32,
    "m5zn.large": 2,
    "m7i-flex.8xlarge": 32,
    "c8g.48xlarge": 192,
    "m6i.24xlarge": 96,
    "c6in.4xlarge": 16,
    "i7i.4xlarge": 16,
    "r5b.metal": 96,
    "m7g.metal": 64,
    "x2iedn.2xlarge": 8,
    "c6a.8xlarge": 32,
    "m6in.large": 2,
    "c6i.2xlarge": 8,
    "r6idn.24xlarge": 96,
    "c7i.2xlarge": 8,
    "r7iz.xlarge": 4,
    "r6id.large": 2,
    "r6a.12xlarge": 48,
    "p3.2xlarge": 8,
    "m5d.16xlarge": 64,
    "d2.4xlarge": 16,
    "c5d.2xlarge": 8,
    "z1d.3xlarge": 12,
    "m5a.24xlarge": 96,
    "m6in.2xlarge": 8,
    "m7i-flex.xlarge": 4,
    "r6in.12xlarge": 48,
    "m6id.large": 2,
    "i3.8xlarge": 32,
    "c7i.16xlarge": 64,
    "c5a.xlarge": 4,
    "c6in.12xlarge": 48,
    "m5.24xlarge": 96,
    "h1.16xlarge": 64,
    "m6gd.medium": 1,
    "i4g.4xlarge": 16,
    "m5n.24xlarge": 96,
    "c6i.8xlarge": 32,
    "r5.24xlarge": 96,
    "m8gd.metal-48xl": 192,
    "i7i.metal-24xl": 96,
    "c6id.xlarge": 4,
    "d2.xlarge": 4,
    "r5b.4xlarge": 16,
    "c6i.12xlarge": 48,
    "c6a.48xlarge": 192,
    "r6in.16xlarge": 64,
    "r5dn.xlarge": 4,
    "m8g.medium": 1,
    "r7i.large": 2,
    "m5dn.xlarge": 4,
    "r5dn.16xlarge": 64,
    "i3en.xlarge": 4,
    "c6a.4xlarge": 16,
    "c7gd.4xlarge": 16,
    "c8gd.medium": 1,
    "c7a.12xlarge": 48,
    "m7i.4xlarge": 16,
    "c6g.xlarge": 4,
    "r6id.xlarge": 4,
    "r5a.16xlarge": 64,
    "r6i.xlarge": 4,
    "x2gd.metal": 64,
    "r8gd.4xlarge": 16,
    "r7iz.4xlarge": 16,
    "m5n.2xlarge": 8,
    "r6g.xlarge": 4,
    "c5ad.4xlarge": 16,
    "m6idn.24xlarge": 96,
    "c5n.large": 2,
    "i3.2xlarge": 8,
    "c6a.metal": 192,
    "i3en.3xlarge": 12,
    "m6id.4xlarge": 16,
    "c5ad.2xlarge": 8,
    "m5a.2xlarge": 8,
    "i7ie.metal-48xl": 192,
    "m5.2xlarge": 8,
    "c7i.48xlarge": 192,
    "r6idn.large": 2,
    "m7i-flex.large": 2,
    "r5n.16xlarge": 64,
    "m7a.metal-48xl": 192,
    "m7a.large": 2,
    "m6idn.2xlarge": 8,
    "m6gd.16xlarge": 64,
    "r7a.48xlarge": 192,
    "m7a.4xlarge": 16,
    "g5.4xlarge": 16,
    "i7i.16xlarge": 64,
    "m6gd.12xlarge": 48,
    "x1e.xlarge": 4,
    "t3.2xlarge": 8,
    "r6g.4xlarge": 16,
    "h1.2xlarge": 8,
    "m6a.xlarge": 4,
    "c6in.24xlarge": 96,
    "i7i.12xlarge": 48,
    "r5dn.12xlarge": 48,
    "c5.12xlarge": 48,
    "d2.2xlarge": 8,
    "m5n.metal": 96,
    "m7i.metal-24xl": 96,
    "c7i-flex.8xlarge": 32,
    "m6idn.32xlarge": 128,
    "m7i.24xlarge": 96,
    "i7i.48xlarge": 192,
    "m5d.large": 2,
    "r6i.24xlarge": 96,
    "x2idn.16xlarge": 64,
    "c6in.8xlarge": 32,
    "m6g.large": 2,
    "x1e.2xlarge": 8,
    "i2.4xlarge": 16,
    "i4i.8xlarge": 32,
    "m5ad.xlarge": 4,
    "c6in.16xlarge": 64,
    "i7ie.3xlarge": 12,
    "r7g.4xlarge": 16,
    "i7i.large": 2,
    "c6gn.8xlarge": 32,
    "r5d.large": 2,
    "c5.large": 2,
    "r5ad.large": 2,
    "m6gd.4xlarge": 16,
    "c6id.8xlarge": 32,
    "p5.48xlarge": 192,
    "g4dn.2xlarge": 8,
    "r5dn.24xlarge": 96,
    "m7gd.large": 2,
    "m6i.xlarge": 4,
    "g6.4xlarge": 16,
    "r7a.24xlarge": 96,
    "r4.8xlarge": 32,
    "i7ie.6xlarge": 24,
    "r7iz.32xlarge": 128,
    "m5a.12xlarge": 48,
    "r5a.4xlarge": 16,
    "c8gd.large": 2,
    "r4.16xlarge": 64,
    "m5ad.24xlarge": 96,
    "m5dn.4xlarge": 16,
    "m7a.2xlarge": 8,
    "r6in.2xlarge": 8,
    "c5ad.24xlarge": 96,
    "c6id.16xlarge": 64,
    "u-3tb1.56xlarge": 224,
    "m5zn.12xlarge": 48,
    "m6g.xlarge": 4,
    "g6.2xlarge": 8,
    "m7gd.metal": 64,
    "r8gd.24xlarge": 96,
    "c5d.4xlarge": 16,
    "c8gd.metal-24xl": 96,
    "r7g.metal": 64,
    "i4g.large": 2,
    "m6idn.4xlarge": 16,
    "m8g.metal-48xl": 192,
    "m6idn.12xlarge": 48,
    "m6g.2xlarge": 8,
    "c6i.32xlarge": 128,
    "t2.2xlarge": 8,
    "r6a.48xlarge": 192,
    "x1e.8xlarge": 32,
    "r5n.2xlarge": 8,
    "i3.16xlarge": 64,
    "r5.8xlarge": 32,
    "i3en.metal": 96,
    "g4ad.xlarge": 4,
    "m6a.32xlarge": 128,
    "r6i.12xlarge": 48,
    "r7iz.2xlarge": 8,
    "i2.8xlarge": 32,
    "d3.4xlarge": 16,
    "c5ad.xlarge": 4,
    "u-24tb1.112xlarge": 448,
    "r5.large": 2,
    "i7ie.2xlarge": 8,
    "c7g.4xlarge": 16,
    "r5n.12xlarge": 48,
    "m7gd.2xlarge": 8,
    "i7ie.metal-24xl": 96,
    "m5d.4xlarge": 16,
    "m5d.12xlarge": 48,
    "g6e.4xlarge": 16,
    "c7gd.12xlarge": 48,
    "m6gd.metal": 64,
    "g4dn.12xlarge": 48,
    "m4.xlarge": 4,
    "m6idn.large": 2,
    "m5a.4xlarge": 16,
    "c7i.4xlarge": 16,
    "inf1.6xlarge": 24,
    "m5ad.2xlarge": 8,
    "m6g.4xlarge": 16,
    "r7i.metal-48xl": 192,
    "x2idn.24xlarge": 96,
    "r6id.12xlarge": 48,
    "g6.12xlarge": 48,
    "x2iedn.4xlarge": 16,
    "z1d.6xlarge": 24,
    "r8gd.8xlarge": 32,
    "m6i.metal": 128,
    "t3.small": 2,
    "c7gd.2xlarge": 8,
    "t4g.small": 2,
    "c5d.12xlarge": 48,
    "c4.2xlarge": 8,
    "c7gd.metal": 64,
    "r7a.metal-48xl": 192,
    "r5n.24xlarge": 96,
    "g5.16xlarge": 64,
    "t3.medium": 2,
    "c6in.xlarge": 4,
    "r6in.32xlarge": 128,
    "t4g.2xlarge": 8,
    "gr6.8xlarge": 32,
    "c6g.medium": 1,
    "t3a.large": 2,
    "t3a.micro": 2,
    "r6gd.12xlarge": 48,
    "m4.4xlarge": 16,
    "c5a.8xlarge": 32,
    "d3.8xlarge": 32,
    "c5a.2xlarge": 8,
    "c6gd.xlarge": 4,
    "r7gd.2xlarge": 8,
    "r5dn.2xlarge": 8,
    "r7iz.large": 2,
    "r7gd.16xlarge": 64,
    "i3.xlarge": 4,
    "m5zn.2xlarge": 8,
    "m6in.8xlarge": 32,
    "m6in.24xlarge": 96,
    "r5dn.metal": 96,
    "i4i.32xlarge": 128,
    "c5ad.12xlarge": 48,
    "r7iz.metal-32xl": 128,
    "m5dn.metal": 96,
    "r6gd.8xlarge": 32,
    "m5.metal": 96,
    "c4.8xlarge": 36,
    "c7i.24xlarge": 96,
    "m6idn.16xlarge": 64,
    "c5ad.16xlarge": 64,
    "u-9tb1.112xlarge": 448,
    "m5n.xlarge": 4,
    "x1e.4xlarge": 16,
    "c6i.4xlarge": 16,
    "c6a.2xlarge": 8,
    "r7gd.12xlarge": 48,
    "c5d.xlarge": 4,
    "m6gd.8xlarge": 32,
    "trn1.32xlarge": 128,
    "x1.32xlarge": 128,
    "g4dn.xlarge": 4,
    "c7a.48xlarge": 192,
    "m7i.2xlarge": 8,
    "r5d.metal": 96,
    "r8g.16xlarge": 64,
    "c7gd.16xlarge": 64,
    "r6g.large": 2,
    "r8gd.large": 2,
    "a1.4xlarge": 16,
    "r7iz.metal-16xl": 64,
    "im4gn.16xlarge": 64,
    "r6in.8xlarge": 32,
    "g6e.24xlarge": 96,
    "c6a.12xlarge": 48,
    "r7i.2xlarge": 8,
    "m6a.16xlarge": 64,
    "r6a.8xlarge": 32,
    "i7i.metal-48xl": 192,
    "r8gd.medium": 1,
    "r6i.8xlarge": 32,
    "c7i.metal-48xl": 192,
    "g4dn.16xlarge": 64,
    "x2gd.2xlarge": 8,
    "c8g.4xlarge": 16,
    "i7ie.18xlarge": 72,
    "r7a.large": 2,
    "m5d.xlarge": 4,
    "c8g.2xlarge": 8,
    "t4g.nano": 2,
    "c7gn.metal": 64,
    "m5n.8xlarge": 32,
    "r6i.16xlarge": 64,
    "m8g.24xlarge": 96,
    "r3.xlarge": 4,
    "x1.16xlarge": 64,
    "c7gn.2xlarge": 8,
    "c6a.24xlarge": 96,
    "c5a.large": 2,
    "c6g.12xlarge": 48,
    "p3.16xlarge": 64,
    "r5b.24xlarge": 96,
    "r8gd.metal-24xl": 96,
    "c7a.2xlarge": 8,
    "m8g.large": 2,
    "m6a.12xlarge": 48,
    "c7gn.medium": 1,
    "r7gd.4xlarge": 16,
    "m6in.4xlarge": 16,
    "m6a.4xlarge": 16,
    "r6i.4xlarge": 16,
    "r5.12xlarge": 48,
    "r5d.2xlarge": 8,
    "inf1.24xlarge": 96,
    "r7a.32xlarge": 128,
    "c7a.16xlarge": 64,
    "c8gd.metal-48xl": 192,
    "c6gd.large": 2,
    "c5.24xlarge": 96,
    "m5zn.xlarge": 4,
    "c7gn.16xlarge": 64,
    "c5a.16xlarge": 64,
    "m7i.12xlarge": 48,
    "h1.8xlarge": 32,
    "c7g.medium": 1,
    "u-12tb1.112xlarge": 448,
    "r8gd.xlarge": 4,
    "r5.xlarge": 4,
    "g4dn.metal": 96,
    "c7gn.12xlarge": 48,
    "m8g.2xlarge": 8,
    "c7i.large": 2,
    "r7gd.xlarge": 4,
    "r6i.32xlarge": 128,
    "m7g.medium": 1,
    "t2.xlarge": 4,
    "c4.large": 2,
    "p5en.48xlarge": 192,
    "m7gd.xlarge": 4,
    "c5n.4xlarge": 16,
    "m6i.4xlarge": 16,
    "r5a.2xlarge": 8,
    "r8g.2xlarge": 8,
    "c8gd.24xlarge": 96,
    "m7i-flex.16xlarge": 64,
    "r5n.4xlarge": 16,
    "t2.medium": 2,
    "r6in.xlarge": 4,
    "m5ad.4xlarge": 16,
    "m7a.medium": 1,
    "c6gd.16xlarge": 64,
    "r7gd.medium": 1,
    "r7i.12xlarge": 48,
    "m7i-flex.2xlarge": 8,
    "m5ad.12xlarge": 48,
    "r6gd.2xlarge": 8,
    "m6a.metal": 192,
    "t2.large": 2,
    "x2idn.32xlarge": 128,
    "c6gd.8xlarge": 32,
    "c7a.xlarge": 4,
    "i7i.xlarge": 4,
    "g5.24xlarge": 96,
    "m7g.xlarge": 4,
    "c5a.4xlarge": 16,
    "m7g.4xlarge": 16,
    "m6gd.2xlarge": 8,
    "i3.4xlarge": 16,
    "m6g.medium": 1,
    "m6idn.8xlarge": 32,
    "r5dn.4xlarge": 16,
    "m7g.16xlarge": 64,
    "m5.16xlarge": 64,
    "r7g.medium": 1,
    "c8g.medium": 1,
    "r5d.xlarge": 4,
    "r8g.metal-24xl": 96,
    "r5a.12xlarge": 48,
    "m7a.24xlarge": 96,
    "m4.large": 2,
    "r8gd.metal-48xl": 192,
    "c8g.16xlarge": 64,
    "c8gd.16xlarge": 64,
    "c8gd.8xlarge": 32,
    "r7i.24xlarge": 96,
    "r4.large": 2,
    "i4i.large": 2,
    "x2gd.large": 2,
    "m8gd.48xlarge": 192,
    "c8gd.xlarge": 4,
    "r7g.16xlarge": 64,
    "r5b.16xlarge": 64,
    "r5ad.12xlarge": 48,
    "g6.24xlarge": 96,
    "g6.8xlarge": 32,
    "c6gd.2xlarge": 8,
    "c7g.12xlarge": 48,
    "g4ad.2xlarge": 8,
    "m7g.large": 2,
    "c6in.32xlarge": 128,
    "t2.small": 1,
    "r8g.large": 2,
    "c6g.8xlarge": 32,
    "x2gd.8xlarge": 32,
    "c7i-flex.large": 2,
    "r6idn.2xlarge": 8,
    "c6gd.12xlarge": 48,
    "im4gn.xlarge": 4,
    "g4ad.16xlarge": 64,
    "m5dn.large": 2,
    "c7gn.8xlarge": 32,
    "r6a.metal": 192,
    "a1.2xlarge": 8,
    "r5b.xlarge": 4,
    "m6g.12xlarge": 48,
    "c7i-flex.4xlarge": 16,
    "p3.8xlarge": 32,
    "g4dn.4xlarge": 16,
    "m8g.4xlarge": 16,
    "r7g.12xlarge": 48,
    "i3.metal": 72,
    "r6gd.xlarge": 4,
    "r6idn.xlarge": 4,
    "m7gd.12xlarge": 48,
    "c7i-flex.16xlarge": 64,
    "c8gd.2xlarge": 8,
    "c6gn.medium": 1,
    "t3.micro": 2,
    "z1d.metal": 48,
    "x2gd.16xlarge": 64,
    "c8g.8xlarge": 32,
    "r6gd.16xlarge": 64,
    "m5n.4xlarge": 16,
    "g6.16xlarge": 64,
    "m8g.12xlarge": 48,
    "m8g.48xlarge": 192,
    "m8gd.xlarge": 4,
    "d2.8xlarge": 36,
    "m7i-flex.4xlarge": 16,
    "c6g.16xlarge": 64,
    "i2.xlarge": 4,
    "r7gd.8xlarge": 32,
    "m7i-flex.12xlarge": 48,
    "i4g.xlarge": 4,
    "c8g.large": 2,
    "c8g.24xlarge": 96,
    "m7g.8xlarge": 32,
    "a1.xlarge": 4,
    "m8gd.large": 2,
    "i4i.24xlarge": 96,
    "c7g.large": 2,
    "x2iedn.8xlarge": 32,
    "g4ad.8xlarge": 32,
    "inf2.8xlarge": 32,
    "m4.16xlarge": 64,
    "r6g.8xlarge": 32,
    "c7g.xlarge": 4,
    "r7g.large": 2,
    "a1.large": 2,
    "g5.2xlarge": 8,
    "z1d.xlarge": 4,
    "i3.large": 2,
    "r8g.8xlarge": 32,
    "c8gd.48xlarge": 192,
    "m8gd.8xlarge": 32,
    "g6e.16xlarge": 64,
    "i7ie.48xlarge": 192,
    "r6in.large": 2,
    "m6g.8xlarge": 32,
    "m6gd.large": 2,
    "m7gd.8xlarge": 32,
    "r4.xlarge": 4,
    "r8gd.2xlarge": 8,
    "gr6.4xlarge": 16,
    "c7i-flex.xlarge": 4,
    "c6gn.2xlarge": 8,
    "r6g.2xlarge": 8,
    "m8gd.12xlarge": 48,
    "g6.48xlarge": 192,
    "m8gd.medium": 1,
    "x2gd.xlarge": 4,
    "inf2.48xlarge": 192,
    "r6g.metal": 64,
    "m8gd.24xlarge": 96,
    "r7g.8xlarge": 32,
    "r6gd.large": 2,
    "c7g.2xlarge": 8,
    "m8gd.2xlarge": 8,
    "r8g.4xlarge": 16,
    "g5.xlarge": 4,
    "t3a.nano": 2,
    "is4gen.8xlarge": 32,
    "r7g.2xlarge": 8,
    "c6g.large": 2,
    "c6gn.xlarge": 4,
    "c6gn.16xlarge": 64,
    "r6gd.metal": 64,
    "c7gn.4xlarge": 16,
    "c7gd.8xlarge": 32,
    "c6g.metal": 64,
    "x2gd.12xlarge": 48,
    "c6gd.medium": 1,
    "m8g.metal-24xl": 96,
    "r8g.xlarge": 4,
    "m6g.metal": 64,
    "x2gd.medium": 1,
    "m6g.16xlarge": 64,
    "im4gn.2xlarge": 8,
    "c6gd.4xlarge": 16,
    "m8gd.metal-24xl": 96,
    "trn1.2xlarge": 8,
    "i4g.2xlarge": 8,
    "inf2.24xlarge": 96,
    "r8g.24xlarge": 96,
    "r6g.12xlarge": 48,
    "g6e.48xlarge": 192,
    "m7g.2xlarge": 8,
    "trn1n.32xlarge": 128,
    "is4gen.large": 2,
    "r6gd.medium": 1,
    "m7g.12xlarge": 48,
    "is4gen.4xlarge": 16,
    "c7g.16xlarge": 64,
    "c6g.4xlarge": 16,
    "is4gen.xlarge": 4,
    "g4ad.4xlarge": 16,
    "i4g.8xlarge": 32,
    "c6g.2xlarge": 8,
    "is4gen.2xlarge": 8,
    "c6gd.metal": 64,
    "c7gd.medium": 1,
    "c8gd.12xlarge": 48,
    "t4g.xlarge": 4,
    "t2.nano": 1,
    "c7g.metal": 64,
    "m7gd.4xlarge": 16,
    "r8g.48xlarge": 192,
    "i4g.16xlarge": 64,
    "c8g.metal-24xl": 96,
    "c8gd.4xlarge": 16,
    "inf2.xlarge": 4,
    "im4gn.8xlarge": 32,
    "x2gd.4xlarge": 16,
    "a1.metal": 16,
    "is4gen.medium": 1,
    "mac1.metal": 12,
    "mac2-m2.metal": 8,
    "mac2.metal": 8,
    "mac2-m2pro.metal": 12,
    "d3en.12xlarge": 48,
    "d3en.8xlarge": 32,
    "x2iezn.12xlarge": 48,
    "u7i-8tb.112xlarge": 448,
    "u7in-24tb.224xlarge": 896,
    "dl1.24xlarge": 96,
    "x8g.48xlarge": 192,
    "u7i-6tb.112xlarge": 448,
    "i8g.2xlarge": 8,
    "c3.4xlarge": 16,
    "x8g.xlarge": 4,
    "c3.large": 2,
    "x2iezn.6xlarge": 24,
    "x8g.large": 2,
    "u7in-32tb.224xlarge": 896,
    "x2iezn.2xlarge": 8,
    "m3.2xlarge": 8,
    "c3.2xlarge": 8,
    "x2iezn.4xlarge": 16,
    "d3en.xlarge": 4,
    "f2.6xlarge": 24,
    "m3.large": 2,
    "f2.12xlarge": 48,
    "d3en.2xlarge": 8,
    "vt1.24xlarge": 96,
    "x2iezn.metal": 48,
    "p3dn.24xlarge": 96,
    "c3.8xlarge": 32,
    "i8g.large": 2,
    "x8g.8xlarge": 32,
    "m3.medium": 1,
    "i8g.16xlarge": 64,
    "x8g.metal-24xl": 96,
    "c3.xlarge": 4,
    "d3en.6xlarge": 24,
    "u7i-12tb.224xlarge": 896,
    "m1.xlarge": 4,
    "hpc7g.8xlarge": 32,
    "m3.xlarge": 4,
    "m1.medium": 1,
    "u7in-16tb.224xlarge": 896,
    "x2iezn.8xlarge": 32,
    "m1.small": 1,
    "i8g.24xlarge": 96,
    "f2.48xlarge": 192,
    "i8g.xlarge": 4,
    "d3en.4xlarge": 16,
    "f1.4xlarge": 16,
    "f1.2xlarge": 8,
    "hpc7g.16xlarge": 64,
    "g5g.metal": 64,
    "x8g.24xlarge": 96,
    "vt1.3xlarge": 12,
    "x8g.12xlarge": 48,
    "i8g.48xlarge": 192,
    "x8g.medium": 1,
    "x8g.16xlarge": 64,
    "p4de.24xlarge": 96,
    "x8g.2xlarge": 8,
    "hpc7g.4xlarge": 16,
    "i8g.4xlarge": 16,
    "x8g.metal-48xl": 192,
    "m1.large": 2,
    "m2.4xlarge": 8,
    "g5g.16xlarge": 64,
    "m2.xlarge": 2,
    "c1.medium": 2,
    "i8g.8xlarge": 32,
    "i8g.metal-24xl": 96,
    "c1.xlarge": 8,
    "g5g.2xlarge": 8,
    "x8g.4xlarge": 16,
    "m2.2xlarge": 4,
    "mac2-m1ultra.metal": 20,
    "g5g.4xlarge": 16,
    "i8g.12xlarge": 48,
    "f1.16xlarge": 64,
    "g5g.xlarge": 4,
    "vt1.6xlarge": 24,
    "g5g.8xlarge": 32,
    "t1.micro": 1,
};
